import { Pipe, PipeTransform } from '@angular/core';
import { AbstractControl, FormArray, FormControl } from '@angular/forms';

/**
 *  Pipe: Los Pipes en Angular son una herramienta que se utiliza para modificar los datos o el formato con que éstos se muestran al usuario final en nuestras aplicaciones.
 *
 *  ## MarkerCategoryByIDPipe
 *
 *  Pipe encargado asignar el estado de **selected** a un elemento.
 */

@Pipe({
  name: 'markerCategoryByID',
  pure: true,
})
export class MarkerCategoryByIDPipe implements PipeTransform {
  /**
   * Pipe encargado de asignar el estado selected a un elemento específico, para esto recibe dos parametros ***id* y **forms**  con los cuales podra identificar y saber a que elemento debe asignarle el estado.
   * @param id Parametro de tipo **number** que servira de identificador para el elemento al cual se desea asignar el estado 'Selected'.
   * @param forms Parametro de tipo **FormArray** que tendra el conjunto de elementos a los cuales se les podra asignar el estado de 'Selected'.
   * @returns parametro de tipo control que contiene el elemento al cual se le asigno el estado de **selected**
   */
  transform(id: number, forms: FormArray): FormControl {
    const index = forms.controls.findIndex((c) => +c.get('id')?.value === id);
    return forms.at(index).get('selected') as FormControl;
  }
}
